import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {FeatureEventData, slotStore} from '@gongxigames/framework/slotV2/globals';

export class WaitRestoredUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.on('Game.command.round.featureStarted', (data: FeatureEventData) => {
            slotStore.batchUpdate({
                feature_type: data
            });
            this.emitter.emit('General.Flow.WAITING_OF_RESTORE_GAME');

            this.removeAllListeners();
            this.onExecuted?.();
        });
    }

    getName(): string {
        return 'WaitRestoredUIAct';
    }
}